import IMask from "imask";


(function(){
    const allInputs = document.querySelectorAll('.wpcf7-form input, .wpcf7-form textarea');
    const type_contacts = document.querySelectorAll('.form .type-contact');
    const contact_blocks = document.querySelectorAll('.form .form__block.contact');
    const inputs = document.querySelectorAll('.form .form__block.contact input');
    const phone = document.getElementById('contact-phone');
    const subject = document.getElementById('contactSubject');
    const defaultData = document.getElementById('contactDefault');
    const contactFile = document.getElementById('contactFile');


    // Set default data (Fields are required)
    let setDefaultValue = () => {
        inputs.forEach((input) => {
            let login_data = defaultData.getAttribute('data-login-'+input.id);
            let default_data = defaultData.getAttribute('data-default-'+input.id);

            input.value = login_data ? login_data : default_data;
        });
    }


    let resetBlocks = (input) => {
        let login_data = defaultData.getAttribute('data-login-'+input.id);

        // If user is authorized set his data
        input.value = login_data ? login_data : '';

        contact_blocks.forEach((contact_block) => {
            contact_block.classList.remove('contact_active');
        });
    }


    let switchType = (id) => {
        let contact = document.querySelector(`.form .form__block.contact[data-type=${id}]`);
        let input = contact.querySelector('input');

        setDefaultValue();
        resetBlocks(input);
        contact.classList.add('contact_active');

        // Update phone mask (10 nums + 1 spacing)
        if(phone) {
            let mask = IMask(phone, {mask: '0000 000000'});
            mask.updateValue();
        }
    }


    if (type_contacts && contact_blocks && inputs && defaultData) {

        // Add default data on load
        if (!phone.value) {
            phone.value = defaultData.getAttribute('data-default-contact-phone');
        }

        type_contacts.forEach((type_contact) => {
            type_contact.addEventListener('input', function () {
                switchType(this.id);
            });
        });
    }


    /*=== Form Validation ===*/

    (function(){
        const forms = document.querySelectorAll('.wpcf7-form');
        const inputs = document.querySelectorAll('.form .type-contact input');


        if (forms && phone && subject && inputs) {
            let prefix = phone.closest('.contact').querySelector('.phone-prefix');
            let select = subject.closest('.custom-select').querySelector('.custom-select__input');


            let checkValid = (elem, child, _class) => {
                setTimeout(() => {
                    elem.classList.contains('wpcf7-not-valid')
                        ? child.classList.add(_class)
                        : child.classList.remove(_class);
                }, 10);
            }


            let resetForm = () => {
                contactFile.value = '';
                let label = contactFile.closest('.form__block').getElementsByTagName('label')[0];
                label.textContent = label.getAttribute('data-text');


                inputs.forEach((item) => {
                    if(item.checked) {
                        let type = item.closest('.type-contact');
                        switchType(type.id);

                        // Reset the custom-select styles
                        select.classList.remove('custom-select__input_checked');
                        select.textContent = select.getAttribute('data-default');
                    }
                })
            }


            forms.forEach((form) => {
                form.addEventListener('wpcf7mailsent', () => { setTimeout(resetForm,0); })

                form.addEventListener('wpcf7invalid', () => {
                    checkValid(phone, prefix, 'phone-prefix_error');
                    checkValid(subject, select, 'wpcf7-not-valid');
                });

                form.addEventListener('submit', () => {
                    checkValid(phone, prefix, 'phone-prefix_error');
                    checkValid(subject, select, 'wpcf7-not-valid');
                });
            });


            phone.addEventListener('blur', () => { checkValid(phone, prefix, 'phone-prefix_error'); });


            phone.addEventListener('focus', () => { checkValid(phone, prefix, 'phone-prefix_error'); });


            if(allInputs) {
                allInputs.forEach((item) => {
                    item.addEventListener('change', () => { checkValid(subject, select, 'wpcf7-not-valid'); });
                });
            }
        }
    })();


    /*=== Phone mask ===*/

    (function(){
        if (phone) {
            let mask = IMask(phone, {mask: '0000 000000'});

            mask.el.input.oninput = () => {
                let val = phone.value;

                phone.value = val;
                mask.updateValue();
            }

            mask.el.input.onkeydown = () => { mask.updateValue(); }
        }
    })();


    /*=== File upload ===*/

    (function(){

        if(contactFile) {
            contactFile.addEventListener('change', function(){
                let file_name = this.files[0].name;
                let label = this.closest('.form__block').getElementsByTagName('label')[0];

                label.textContent = file_name;
            });
        }
    })();
})();



